import EventsWidgetForm from './EventsWidgetForm';

export default EventsWidgetForm;
